import { IsMobileDevice } from 'source/app/domain/Device/Helpers/IsMobile';
import { TSwalOptions } from '../RenderSwal';
const cashJS = require('cash-dom');

const classIdentifier = '.swal2-container';

export const ShockSwalBackground = (swalOptions: TSwalOptions) => {
	const { shockBackgroundColor, timer } = swalOptions;

	if (shockBackgroundColor && timer) {
		Render(shockBackgroundColor, timer);
	}
};

const Render = (cssColor: string, durationInMilliseconds: number) => {
	SetColor(cssColor, 0);
	FlashLightning(cssColor, durationInMilliseconds);
	FadeOut(durationInMilliseconds);
};

const ContainerElementExists = () => {
	const containerElement = cashJS(classIdentifier);
	return containerElement.length > 0;
};

const SetColor = (cssColor: string, afterMilliseconds: number) => {
	if (ContainerElementExists()) {
		setTimeout(
			() => cashJS(classIdentifier).css('background-color', cssColor),
			afterMilliseconds
		);
	}
};

const SetOpacity = (opacity: number, afterMilliseconds: number) => {
	if (ContainerElementExists()) {
		setTimeout(
			() => cashJS(classIdentifier).css('opacity', String(opacity)),
			afterMilliseconds
		);
	}
};

const FadeOut = (totalDurationInMilliseconds: number) => {
	if (totalDurationInMilliseconds > 300) {
		SetOpacity(0.75, totalDurationInMilliseconds - 300);
		SetOpacity(0.5, totalDurationInMilliseconds - 200);
		SetOpacity(0.25, totalDurationInMilliseconds - 100);
	}
};

const FlashLightning = (
	cssColor: string,
	totalDurationInMilliseconds: number
) => {
	if (totalDurationInMilliseconds > 600) {
		SetColor('white', totalDurationInMilliseconds - 600);
		SetColor(cssColor, totalDurationInMilliseconds - 500);
	}
};
